module.exports = __webpack_public_path__ + "static/media/bg_cover_page.ebcf5c9b.jpg";